/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { loadCldr, L10n } from '@syncfusion/ej2-base';

import { DivCustom } from './styles';

const InputDate = ({ onChange, className, error, value, placeholder }) => {
  const { selectedDefaultLanguage } = useSelector((state) => state.topBar);
  const language =
    selectedDefaultLanguage === 'eu-ES' ? 'eu' : selectedDefaultLanguage.split('-')[0];
  loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require(`cldr-data/main/es/ca-gregorian.json`),
    require(`cldr-data/main/es/numbers.json`),
    require(`cldr-data/main/es/timeZoneNames.json`),
    require(`cldr-data/main/en/ca-gregorian.json`),
    require(`cldr-data/main/en/numbers.json`),
    require(`cldr-data/main/en/timeZoneNames.json`),
    require(`cldr-data/main/fr/ca-gregorian.json`),
    require(`cldr-data/main/fr/numbers.json`),
    require(`cldr-data/main/fr/timeZoneNames.json`),
    require(`cldr-data/main/it/ca-gregorian.json`),
    require(`cldr-data/main/it/numbers.json`),
    require(`cldr-data/main/it/timeZoneNames.json`),
    require(`cldr-data/main/ca/ca-gregorian.json`),
    require(`cldr-data/main/ca/numbers.json`),
    require(`cldr-data/main/ca/timeZoneNames.json`),
    require(`cldr-data/main/eu/ca-gregorian.json`),
    require(`cldr-data/main/eu/numbers.json`),
    require(`cldr-data/main/eu/timeZoneNames.json`)
  );
  L10n.load({
    es: {
      datepicker: {
        today: 'Hoy',
      },
    },
    en: {
      datepicker: {
        today: 'Today',
      },
    },
    fr: {
      datepicker: {
        today: "Aujourd'hui'",
      },
    },
    ca: {
      datepicker: {
        today: 'Avui',
      },
    },
    it: {
      datepicker: {
        today: 'Oggi',
      },
    },
  });
  return (
    <DivCustom
      className={classNames(
        {
          'form__form-group-field': true,
          'form__form-group-field--error': error,
        },
        className
      )}
    >
      <DatePickerComponent
        value={value === 'Invalid date' ? '' : value}
        onChange={onChange}
        format="dd/MM/yyyy"
        placeholder={placeholder}
        locale={language}
        firstDayOfWeek={1}
      />
    </DivCustom>
  );
};

InputDate.defaultProps = {
  className: '',
  error: false,
  value: undefined,
  onChange: undefined,
  placeholder: '',
};

InputDate.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  placeholder: PropTypes.string,
};

export default InputDate;
